var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import CustomiserBase from './CustomiserBase';
import React from 'react';
import { createRoot } from 'react-dom/client';
const init = () => __awaiter(void 0, void 0, void 0, function* () {
    const container = document.querySelector('[data-cg-product-hero]');
    if (container) {
        const productHandle = container.dataset.cgProductHero;
        const productRating = container.dataset.cgProductRatingHtml;
        // Bundle Single Flow: Single Product with Dynamic Image
        if (container) {
            let productData = yield fetch(`${window.Shopify.routes.root}products/${productHandle}?view=customiser-context.json`).then((data) => data.json());
            setTimeout(() => {
                const baseRoot = createRoot(container);
                baseRoot.render(React.createElement(CustomiserBase, Object.assign({}, productData, { productRating: productRating })));
            }, 800);
        }
    }
});
export default {
    init,
};
